import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const scrollPositions = useRef({});
  const previousPathname = useRef(null);

  useEffect(() => {
    // Save the current page's scroll position before navigation
    if (previousPathname.current && previousPathname.current !== pathname) {
      scrollPositions.current[previousPathname.current] = window.scrollY;
    }

    // Determine scroll behavior based on navigation direction
    const isNavigatingBack = scrollPositions.current[pathname] !== undefined;

    // Scroll to the appropriate position
    if (isNavigatingBack) {
      // If navigating back, restore previous scroll position
      window.scrollTo({
        top: scrollPositions.current[pathname],
        left: 0,
        behavior: 'smooth',
      });
    } else {
      // If navigating forward, always scroll to top
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }

    // Update previous pathname
    previousPathname.current = pathname;
  }, [pathname]);

  return null;
};

export default ScrollToTop;